// import React from 'react';
// import { Routes, Route } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import HomePage from './pages/HomePage';


// function App() {
//   return (
//     <>
//       <Navbar />
//       <Routes>
//         <Route path='/' element={<HomePage />} />

//       </Routes>
//     </>
//   );
// }

// export default App;


// // import React from 'react';
// // import AppLayout from './components/AppLayout';
// // import HomePage from './pages/HomePage';

// // function App() {
// //   return (
// //     <AppLayout>
// //       <HomePage />
// //     </AppLayout>
// //   );
// // }

// // export default App;


import React from "react";
import {
  Phone,
  Globe,
  MapPin,
  ShieldCheck,
  Truck,
  BadgeDollarSign,
  Activity,
  HeartPulse,
  Wind,
  Accessibility,
  Bed,
  Stethoscope,
} from "lucide-react";

import "./App.css";

const mainEquipment = [
  {
    name: "Oxygen Concentrators",
    image:
      '/assets/equipment5.webp',
    icon: Wind,
  },
  {
    name: "BiPAP / CPAP Machines",
    image:
      "https://images.unsplash.com/photo-1584515933487-779824d29309?w=500",
    icon: Activity,
  },
  {
    name: "Patient Monitors",
    image:
      "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=500",
    icon: HeartPulse,
  },
  {
    name: "Ventilators",
    image:
      "https://images.unsplash.com/photo-1585435557343-3b092031a831?w=500",
    icon: Wind,
  },
  {
    name: "Wheelchairs",
    image:
      "https://images.unsplash.com/photo-1586351012965-861624544334?w=500",
    icon: Accessibility,
  },
  {
    name: "Hospital Beds",
    image:
      "https://images.unsplash.com/photo-1516841273335-e39b37888115?w=500",
    icon: Bed,
  },
];

const otherEquipment = [
  {
    name: "Suction Machines",
    icon: Activity,
  },
  {
    name: "Infusion & Syringe Pumps",
    icon: Activity,
  },
  {
    name: "ECG Machines",
    icon: HeartPulse,
  },
  {
    name: "Nebulizer Machines",
    icon: Wind,
  },
  {
    name: "Air Therapy & HNFC",
    icon: Wind,
  },
  {
    name: "CPM Machines",
    icon: Accessibility,
  },
  {
    name: "DVT Pumps",
    icon: Activity,
  },
  {
    name: "IV Stand",
    icon: Stethoscope,
  },
  {
    name: "Portable Ventilator",
    icon: Wind,
  },
  {
    name: "Cardiac Monitor",
    icon: HeartPulse,
  },
  {
    name: "Electric Hospital Bed",
    icon: Bed,
  },
  {
    name: "Walkers & More",
    icon: Accessibility,
  },
];

function App() {
  return (
    <div className="page">

      {/* HEADER */}
      <header className="header">
        <div className="logo">
          <div className="logo-box">N</div>

          <div>
            <h2>NIRMAY</h2>
            <span>TECHNOLOGIES</span>
          </div>
        </div>

        <nav>
          <a href="#home">Home</a>
          <a href="#equipment">Equipment</a>
          <a href="#services">Services</a>
          <a href="#contact">Contact</a>
        </nav>

        <button className="header-btn">
          <Phone size={17} />
          Call Now
        </button>
      </header>

      {/* HERO */}
      <section className="hero" id="home">

        <div className="hero-content">

          <div className="company-logo-mobile">
            <div className="logo-box">N</div>
            <div>
              <strong>Nirmay</strong>
              <small>Technologies</small>
            </div>
          </div>

          <p className="small-title">YOUR HEALTH. OUR PRIORITY.</p>

          <h1>
            MEDICAL
            <br />
            EQUIPMENT
          </h1>

          <div className="rental">
            RENTAL <span>&</span> SALES
          </div>

          <div className="features">
            <div>
              <ShieldCheck size={17} />
              <span>Quality Equipment</span>
            </div>

            <div>
              <BadgeDollarSign size={17} />
              <span>Affordable Rates</span>
            </div>

            <div>
              <Truck size={17} />
              <span>Fast Delivery</span>
            </div>
          </div>

          <div className="hero-location">
            <MapPin size={20} />
            <span>SERVING BANGALORE</span>
          </div>

        </div>

        <div className="hero-image">

          <div className="safe-badge">
            <ShieldCheck size={28} />
            <strong>SANITIZED</strong>
            <span>SAFE</span>
            <span>RELIABLE</span>
          </div>

          <div className="people-image">
            <div className="doctor">
              <div className="doctor-head"></div>
              <div className="doctor-body">
                <div className="stethoscope"></div>
              </div>
            </div>

            <div className="patient">
              <div className="patient-head"></div>
              <div className="patient-body"></div>
            </div>
          </div>

        </div>
      </section>

      {/* CATEGORY BAR */}
      <section className="category-bar">

        <div>
          <Wind />
          <span>OXYGEN<br />CONCENTRATORS</span>
        </div>

        <div>
          <Activity />
          <span>BIPAP / CPAP<br />MACHINES</span>
        </div>

        <div>
          <Activity />
          <span>PATIENT<br />MONITORS</span>
        </div>

        <div>
          <Wind />
          <span>VENTILATORS</span>
        </div>

        <div>
          <Accessibility />
          <span>WHEELCHAIRS</span>
        </div>

        <div>
          <Bed />
          <span>HOSPITAL<br />BEDS</span>
        </div>

      </section>

      {/* MAIN EQUIPMENT */}
      <section className="equipment-section" id="equipment">

        <div className="section-title">
          <span></span>
          <h2>FEATURED MEDICAL EQUIPMENT</h2>
          <span></span>
        </div>

        <div className="equipment-grid">

          {mainEquipment.map((item, index) => {
            const Icon = item.icon;

            return (
              <div className="equipment-card" key={index}>

                <div className="equipment-image">
                  <img
                    src={item.image}
                    alt={item.name}
                  />
                </div>

                <div className="equipment-name">
                  <Icon size={18} />
                  <span>{item.name}</span>
                </div>

                <button>
                  View Details
                </button>

              </div>
            );
          })}

        </div>
      </section>

      {/* OTHER EQUIPMENT */}
      <section className="other-section" id="services">

        <div className="section-title">
          <span></span>
          <h2>MORE EQUIPMENT WE OFFER</h2>
          <span></span>
        </div>

        <div className="other-grid">

          {otherEquipment.map((item, index) => {
            const Icon = item.icon;

            return (
              <div className="other-card" key={index}>

                <div className="other-icon">
                  <Icon size={32} />
                </div>

                <div>
                  <h3>{item.name}</h3>
                  <p>Available for rental & sale</p>
                </div>

              </div>
            );
          })}

        </div>

      </section>

      {/* CONTACT */}
      <section className="contact-section" id="contact">

        <div className="contact-item">

          <div className="contact-icon">
            <Phone />
          </div>

          <div>
            <small>CALL US NOW</small>
            <strong>8970549959</strong>
          </div>

        </div>

        <div className="divider"></div>

        <div className="contact-item">

          <div className="contact-icon">
            <Globe />
          </div>

          <div>
            <small>VISIT OUR WEBSITE</small>
            <strong>www.nirmaytechnologies.com</strong>
          </div>

        </div>

      </section>

      {/* FOOTER */}
      <footer>
        <span>© 2026 Nirmay Technologies</span>

        <div>
          Medical Equipment Rental & Sales
        </div>
      </footer>

    </div>
  );
}

export default App;